"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _NotRepresentableException = _interopRequireDefault(require("./NotRepresentableException"));

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _Orientation = _interopRequireDefault(require("./Orientation"));

var _CGAlgorithmsDD = _interopRequireDefault(require("./CGAlgorithmsDD"));

var _System = _interopRequireDefault(require("../../../../java/lang/System"));

var _HCoordinate = _interopRequireDefault(require("./HCoordinate"));

var _Envelope = _interopRequireDefault(require("../geom/Envelope"));

var _Distance = _interopRequireDefault(require("./Distance"));

var _LineIntersector2 = _interopRequireDefault(require("./LineIntersector"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var RobustLineIntersector =
/*#__PURE__*/
function (_LineIntersector) {
  _inherits(RobustLineIntersector, _LineIntersector);

  function RobustLineIntersector() {
    var _this;

    _classCallCheck(this, RobustLineIntersector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RobustLineIntersector).call(this));
    RobustLineIntersector.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(RobustLineIntersector, [{
    key: "isInSegmentEnvelopes",
    value: function isInSegmentEnvelopes(intPt) {
      var env0 = new _Envelope.default(this._inputLines[0][0], this._inputLines[0][1]);
      var env1 = new _Envelope.default(this._inputLines[1][0], this._inputLines[1][1]);
      return env0.contains(intPt) && env1.contains(intPt);
    }
  }, {
    key: "computeIntersection",
    value: function computeIntersection() {
      if (arguments.length === 3) {
        var p = arguments[0],
            p1 = arguments[1],
            p2 = arguments[2];
        this._isProper = false;

        if (_Envelope.default.intersects(p1, p2, p)) {
          if (_Orientation.default.index(p1, p2, p) === 0 && _Orientation.default.index(p2, p1, p) === 0) {
            this._isProper = true;

            if (p.equals(p1) || p.equals(p2)) {
              this._isProper = false;
            }

            this._result = _LineIntersector2.default.POINT_INTERSECTION;
            return null;
          }
        }

        this._result = _LineIntersector2.default.NO_INTERSECTION;
      } else return _get(_getPrototypeOf(RobustLineIntersector.prototype), "computeIntersection", this).apply(this, arguments);
    }
  }, {
    key: "normalizeToMinimum",
    value: function normalizeToMinimum(n1, n2, n3, n4, normPt) {
      normPt.x = this.smallestInAbsValue(n1.x, n2.x, n3.x, n4.x);
      normPt.y = this.smallestInAbsValue(n1.y, n2.y, n3.y, n4.y);
      n1.x -= normPt.x;
      n1.y -= normPt.y;
      n2.x -= normPt.x;
      n2.y -= normPt.y;
      n3.x -= normPt.x;
      n3.y -= normPt.y;
      n4.x -= normPt.x;
      n4.y -= normPt.y;
    }
  }, {
    key: "safeHCoordinateIntersection",
    value: function safeHCoordinateIntersection(p1, p2, q1, q2) {
      var intPt = null;

      try {
        intPt = _HCoordinate.default.intersection(p1, p2, q1, q2);
      } catch (e) {
        if (e instanceof _NotRepresentableException.default) {
          intPt = RobustLineIntersector.nearestEndpoint(p1, p2, q1, q2);
        } else throw e;
      } finally {}

      return intPt;
    }
  }, {
    key: "intersection",
    value: function intersection(p1, p2, q1, q2) {
      var intPt = this.intersectionWithNormalization(p1, p2, q1, q2);

      if (!this.isInSegmentEnvelopes(intPt)) {
        intPt = new _Coordinate.default(RobustLineIntersector.nearestEndpoint(p1, p2, q1, q2));
      }

      if (this._precisionModel !== null) {
        this._precisionModel.makePrecise(intPt);
      }

      return intPt;
    }
  }, {
    key: "smallestInAbsValue",
    value: function smallestInAbsValue(x1, x2, x3, x4) {
      var x = x1;
      var xabs = Math.abs(x);

      if (Math.abs(x2) < xabs) {
        x = x2;
        xabs = Math.abs(x2);
      }

      if (Math.abs(x3) < xabs) {
        x = x3;
        xabs = Math.abs(x3);
      }

      if (Math.abs(x4) < xabs) {
        x = x4;
      }

      return x;
    }
  }, {
    key: "checkDD",
    value: function checkDD(p1, p2, q1, q2, intPt) {
      var intPtDD = _CGAlgorithmsDD.default.intersection(p1, p2, q1, q2);

      var isIn = this.isInSegmentEnvelopes(intPtDD);

      _System.default.out.println("DD in env = " + isIn + "  --------------------- " + intPtDD);

      if (intPt.distance(intPtDD) > 0.0001) {
        _System.default.out.println("Distance = " + intPt.distance(intPtDD));
      }
    }
  }, {
    key: "intersectionWithNormalization",
    value: function intersectionWithNormalization(p1, p2, q1, q2) {
      var n1 = new _Coordinate.default(p1);
      var n2 = new _Coordinate.default(p2);
      var n3 = new _Coordinate.default(q1);
      var n4 = new _Coordinate.default(q2);
      var normPt = new _Coordinate.default();
      this.normalizeToEnvCentre(n1, n2, n3, n4, normPt);
      var intPt = this.safeHCoordinateIntersection(n1, n2, n3, n4);
      intPt.x += normPt.x;
      intPt.y += normPt.y;
      return intPt;
    }
  }, {
    key: "computeCollinearIntersection",
    value: function computeCollinearIntersection(p1, p2, q1, q2) {
      var p1q1p2 = _Envelope.default.intersects(p1, p2, q1);

      var p1q2p2 = _Envelope.default.intersects(p1, p2, q2);

      var q1p1q2 = _Envelope.default.intersects(q1, q2, p1);

      var q1p2q2 = _Envelope.default.intersects(q1, q2, p2);

      if (p1q1p2 && p1q2p2) {
        this._intPt[0] = q1;
        this._intPt[1] = q2;
        return _LineIntersector2.default.COLLINEAR_INTERSECTION;
      }

      if (q1p1q2 && q1p2q2) {
        this._intPt[0] = p1;
        this._intPt[1] = p2;
        return _LineIntersector2.default.COLLINEAR_INTERSECTION;
      }

      if (p1q1p2 && q1p1q2) {
        this._intPt[0] = q1;
        this._intPt[1] = p1;
        return q1.equals(p1) && !p1q2p2 && !q1p2q2 ? _LineIntersector2.default.POINT_INTERSECTION : _LineIntersector2.default.COLLINEAR_INTERSECTION;
      }

      if (p1q1p2 && q1p2q2) {
        this._intPt[0] = q1;
        this._intPt[1] = p2;
        return q1.equals(p2) && !p1q2p2 && !q1p1q2 ? _LineIntersector2.default.POINT_INTERSECTION : _LineIntersector2.default.COLLINEAR_INTERSECTION;
      }

      if (p1q2p2 && q1p1q2) {
        this._intPt[0] = q2;
        this._intPt[1] = p1;
        return q2.equals(p1) && !p1q1p2 && !q1p2q2 ? _LineIntersector2.default.POINT_INTERSECTION : _LineIntersector2.default.COLLINEAR_INTERSECTION;
      }

      if (p1q2p2 && q1p2q2) {
        this._intPt[0] = q2;
        this._intPt[1] = p2;
        return q2.equals(p2) && !p1q1p2 && !q1p1q2 ? _LineIntersector2.default.POINT_INTERSECTION : _LineIntersector2.default.COLLINEAR_INTERSECTION;
      }

      return _LineIntersector2.default.NO_INTERSECTION;
    }
  }, {
    key: "normalizeToEnvCentre",
    value: function normalizeToEnvCentre(n00, n01, n10, n11, normPt) {
      var minX0 = n00.x < n01.x ? n00.x : n01.x;
      var minY0 = n00.y < n01.y ? n00.y : n01.y;
      var maxX0 = n00.x > n01.x ? n00.x : n01.x;
      var maxY0 = n00.y > n01.y ? n00.y : n01.y;
      var minX1 = n10.x < n11.x ? n10.x : n11.x;
      var minY1 = n10.y < n11.y ? n10.y : n11.y;
      var maxX1 = n10.x > n11.x ? n10.x : n11.x;
      var maxY1 = n10.y > n11.y ? n10.y : n11.y;
      var intMinX = minX0 > minX1 ? minX0 : minX1;
      var intMaxX = maxX0 < maxX1 ? maxX0 : maxX1;
      var intMinY = minY0 > minY1 ? minY0 : minY1;
      var intMaxY = maxY0 < maxY1 ? maxY0 : maxY1;
      var intMidX = (intMinX + intMaxX) / 2.0;
      var intMidY = (intMinY + intMaxY) / 2.0;
      normPt.x = intMidX;
      normPt.y = intMidY;
      n00.x -= normPt.x;
      n00.y -= normPt.y;
      n01.x -= normPt.x;
      n01.y -= normPt.y;
      n10.x -= normPt.x;
      n10.y -= normPt.y;
      n11.x -= normPt.x;
      n11.y -= normPt.y;
    }
  }, {
    key: "computeIntersect",
    value: function computeIntersect(p1, p2, q1, q2) {
      this._isProper = false;
      if (!_Envelope.default.intersects(p1, p2, q1, q2)) return _LineIntersector2.default.NO_INTERSECTION;

      var Pq1 = _Orientation.default.index(p1, p2, q1);

      var Pq2 = _Orientation.default.index(p1, p2, q2);

      if (Pq1 > 0 && Pq2 > 0 || Pq1 < 0 && Pq2 < 0) {
        return _LineIntersector2.default.NO_INTERSECTION;
      }

      var Qp1 = _Orientation.default.index(q1, q2, p1);

      var Qp2 = _Orientation.default.index(q1, q2, p2);

      if (Qp1 > 0 && Qp2 > 0 || Qp1 < 0 && Qp2 < 0) {
        return _LineIntersector2.default.NO_INTERSECTION;
      }

      var collinear = Pq1 === 0 && Pq2 === 0 && Qp1 === 0 && Qp2 === 0;

      if (collinear) {
        return this.computeCollinearIntersection(p1, p2, q1, q2);
      }

      if (Pq1 === 0 || Pq2 === 0 || Qp1 === 0 || Qp2 === 0) {
        this._isProper = false;

        if (p1.equals2D(q1) || p1.equals2D(q2)) {
          this._intPt[0] = p1;
        } else if (p2.equals2D(q1) || p2.equals2D(q2)) {
          this._intPt[0] = p2;
        } else if (Pq1 === 0) {
          this._intPt[0] = new _Coordinate.default(q1);
        } else if (Pq2 === 0) {
          this._intPt[0] = new _Coordinate.default(q2);
        } else if (Qp1 === 0) {
          this._intPt[0] = new _Coordinate.default(p1);
        } else if (Qp2 === 0) {
          this._intPt[0] = new _Coordinate.default(p2);
        }
      } else {
        this._isProper = true;
        this._intPt[0] = this.intersection(p1, p2, q1, q2);
      }

      return _LineIntersector2.default.POINT_INTERSECTION;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RobustLineIntersector;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "nearestEndpoint",
    value: function nearestEndpoint(p1, p2, q1, q2) {
      var nearestPt = p1;

      var minDist = _Distance.default.pointToSegment(p1, q1, q2);

      var dist = _Distance.default.pointToSegment(p2, q1, q2);

      if (dist < minDist) {
        minDist = dist;
        nearestPt = p2;
      }

      dist = _Distance.default.pointToSegment(q1, p1, p2);

      if (dist < minDist) {
        minDist = dist;
        nearestPt = q1;
      }

      dist = _Distance.default.pointToSegment(q2, p1, p2);

      if (dist < minDist) {
        minDist = dist;
        nearestPt = q2;
      }

      return nearestPt;
    }
  }]);

  return RobustLineIntersector;
}(_LineIntersector2.default);

exports.default = RobustLineIntersector;

RobustLineIntersector.constructor_ = function () {};